import { Component, OnInit } from '@angular/core';
import { PreconnectService } from './core/services/preconnect.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'mytag';

  constructor(
    private preconnectService: PreconnectService
  ) {}

  ngOnInit(): void {
    this.preconnectService.setupPreconnectLinks();
  }
}
